// Teacher-hours copy — NL, verbatim from the ratified golden mock
// ~/mockups/2026-09/teacher-hours-week.html (rev 2, Artem 2026-09-23).
// Namespace `teacherHours`. Dynamic values are i18next {{placeholders}};
// <b>/<br/> are Trans tags. EN twin: teacherHours.en.ts (identical keys, parity-tested).
export const teacherHoursNl = {
  units: { hoursShort: ' u', free: ' vrij', extra: ' extra', hoursWord: '{{n}} uur', zeroHours: '0 uur' },
  weekdayShort: { sun: 'zo', mon: 'ma', tue: 'di', wed: 'wo', thu: 'do', fri: 'vr', sat: 'za' },
  weekdayLong: { sun: 'zondag', mon: 'maandag', tue: 'dinsdag', wed: 'woensdag', thu: 'donderdag', fri: 'vrijdag', sat: 'zaterdag' },
  monthShort: { jan: 'jan', feb: 'feb', mar: 'mrt', apr: 'apr', may: 'mei', jun: 'jun', jul: 'jul', aug: 'aug', sep: 'sep', oct: 'okt', nov: 'nov', dec: 'dec' },
  monthLong: {
    jan: 'januari', feb: 'februari', mar: 'maart', apr: 'april', may: 'mei', jun: 'juni',
    jul: 'juli', aug: 'augustus', sep: 'september', oct: 'oktober', nov: 'november', dec: 'december',
  },
  leaveTypes: {
    vacation: 'Vakantie',
    appointment: 'Dokter of tandarts',
    care_short: 'Zorg voor een ander',
    special: 'Bijzonder verlof',
  },
  leaveTypesShort: { vacation: 'Vakantie', appointment: 'Dokter', care_short: 'Zorg', special: 'Bijzonder' },
  hoursKinds: {
    meeruren: 'Extra tijd',
    correction: 'Minder gewerkt',
    break_edit: 'Pauze gemist',
    plus_payout: 'Extra uren uitbetalen',
    plus_verlof: 'Extra uren naar vrij',
  },
  zeroReasons: {
    no_roster_yet_many: 'Geen rooster op deze data, dus 0 u afgeschreven',
    no_roster_yet_one: 'Geen rooster op deze datum, dus 0 u afgeschreven',
    one_off_only: 'Je rooster stond hier alleen als losse dag, dus 0 u afgeschreven',
    no_regular_roster: 'Geen vast rooster gevonden, dus 0 u afgeschreven',
  },
  notes: {
    movedFromPortabase: 'Verlof (overgezet uit Portabase)',
    requestedInApp: 'Aangevraagd in de app',
    removedByManager: 'Uit je rooster gehaald door je manager',
    shorterDay: 'Kortere dag {{from}}–{{to}}',
    overlapFuneral: 'Valt samen met je uitvaartverlof op {{date}}: één keer afgeschreven ({{hours}})',
    convertedToCare: 'Omgezet naar zorg voor een ander',
    convertedFromExtra: 'Omgezet vanuit extra tijd: “{{reason}}”',
  },
  shell: {
    role: { teacher: 'Pedagogisch medewerker', manager: 'Manager (glimp)' },
    hello: 'Hoi {{name}}',
    contractMeta: 'Contract {{hours}} u/week · vaste rooster {{days}} u netto',
    provisional: 'voorlopig',
    tabs: { week: 'Mijn week', year: 'Mijn jaar', gewerkt: 'Gewerkt', requests: 'Aanvragen' },
    myBalance: 'Mijn saldo',
    newRequest: 'Nieuwe aanvraag',
  },
  dock: {
    leaveRequested: ' verlof aangevraagd',
    extraAwaiting: ' extra wacht op akkoord',
    questionTitle: 'Je manager heeft een vraag',
    about: 'over',
    answer: 'Beantwoorden',
  },
  week: {
    planningNoteLegend: 'notitie van planning',
    prev: 'Vorige week',
    next: 'Volgende week',
    week: 'Week',
    thisWeek: ' · deze week',
    earlierWeeksNote:
      'Eerdere weken zie je hier niet: je rooster staat pas vanaf 15 jun in het systeem, en tot eind juli alleen als losse dagen. Je vakanties uit die tijd staan wel bij <b>Aanvragen</b>, gemarkeerd.',
    sum: { contract: 'Contract', roster: 'Rooster', away: 'Afwezig', yearHours: 'Jaaruren' },
    openRequestsTitle: '{{count}} eerdere aanvragen wachten nog op akkoord',
    openRequestsTail: ', de oudste sinds {{date}} ({{days}} dagen). Bekijk ›',
    patternLine: 'Vaste rooster {{pattern}}, contract {{contract}} ({{gap}}). Met je dagen ({{days}}) telt deze week {{week}}.',
    pendingLine: 'Plus {{hours}} die nog wacht op akkoord (gestreept, telt nog niet mee).',
    dayOff: 'Vrije dag · geen rooster',
    holidayCounts: 'telt 0 u',
    noRosterKnown: 'Geen rooster bekend',
    publicHoliday: 'Feestdag',
    breakSuffix: ' · 60 min pauze',
    net: 'netto',
    planned: 'gepland',
    unknownGroup: 'groep niet gevonden',
    footer:
      'Tik op een dag voor extra tijd, vrij vragen of “iets klopt niet”.<br/>± = wat deze dag doet met je jaaruren (rooster − vaste rooster + goedgekeurde extra tijd).',
  },
  chips: {
    awaitingApproval: 'wacht op akkoord',
    bookedTwiceOnce: 'dubbel geboekt · 1× afgeschreven',
    zeroFromBalance: '0 u van je saldo',
    partlyFromExtra: ' · deels uit extra uren',
    fromExtra: ' · uit extra uren',
    approved: 'goedgekeurd',
    addedByManager: ' · toegevoegd door je manager',
    declined: 'afgewezen',
    managerHasQuestion: 'je manager heeft een vraag',
    alsoHolidayDay: 'ook een vakantiedag',
    onHolidayDay: 'op een vakantiedag',
    priority: 'Prioriteit',
    autoApproved: 'Automatisch goedgekeurd',
    zeroDeducted: '0 u afgeschreven',
    bookedTwice: 'dubbel geboekt',
    notFromBalance: 'gaat niet van je saldo af',
    fromExtraHours: 'uit extra uren',
    awaitingPayroll: 'wacht op salarisverwerking',
    holidayDay: 'vakantiedag',
    twiceOnce: 'dubbel · 1× afgeschreven',
  },
  decision: {
    none: 'Besluit: niet van je saldo',
    vacationPlus: 'Besluit: bij je vakantie-uren',
    vacationMinus: 'Besluit: van je vakantie-uren',
    extraPlus: 'Besluit: bij je extra uren',
    extraMinus: 'Besluit: uit je extra uren',
    split: 'Besluit: {{vacation}} vakantie + {{extra}} extra uren',
  },
  status: {
    pending: 'wacht op akkoord',
    question: 'vraag van je manager',
    approved: 'goedgekeurd',
    paidOut: 'uitbetaald',
    rejected: 'afgewezen',
    withdrawn: 'ingetrokken',
  },
  timeline: {
    sent: 'Ingediend',
    withManager: 'Bij je manager',
    declined: 'Afgewezen',
    withdrawn: 'Ingetrokken',
    decision: 'Besluit',
    inSalary: 'In je salaris',
  },
  history: {
    managerReason: 'Reden van je manager:',
    managerNote: 'Notitie van je manager:',
    yourAnswer: 'Jouw antwoord:',
    openSince: 'open sinds',
    days: 'dagen',
    withdraw: 'Intrekken',
    requested: 'aangevraagd',
    toExtraStatutory: ' · komt bij je bovenwettelijke uren',
    withNextSalary: ' · met je volgende salaris',
    zeroNoteTail:
      'Daardoor is je saldo nu te hoog. HR zet dit recht zodra je oude rooster erin staat; tot dan is je saldo <b>voorlopig</b>.',
    filters: { all: 'Alles', waiting: 'Wacht', approved: 'Goedgekeurd', declined: 'Afgewezen', check: 'Let op' },
    checkNote:
      'Dit zijn geen fouten van jou. Het systeem laat ze zien in plaats van ze stil weg te laten. Je manager of HR zet ze recht.',
    emptyTitle: 'Niets hier',
    emptyBody: 'Geen aanvragen in deze lijst.',
    withdrawnToast: 'Aanvraag ingetrokken',
  },
  day: {
    week: 'Week',
    past: 'geweest',
    planned: 'gepland',
    roster: 'Rooster',
    noRosterYet: 'nog geen rooster in het systeem',
    minusContract: 'Min je vaste rooster voor deze dag',
    holidayCounts: ': telt 0 u',
    yourRegular: 'je vaste ',
    approvedExtra: 'Goedgekeurde extra tijd / correcties',
    shorterCovered: 'Kortere dag gedekt door verlof',
    notMinusHours: 'telt niet als min-uren',
    total: 'Deze dag voor je jaaruren',
    awaitingSuffix: ' (wacht op akkoord)',
    leaveCountsWorked: 'verlof telt als gewerkt voor je jaaruren',
    removedNote:
      'Deze dag is uit je rooster gehaald, dus −{{hours}} op je jaaruren. Heb je toch gewerkt of was je vrij? Dat staat hieronder bij je aanvragen.',
    twoLeaveTitle: 'Twee verlofaanvragen op deze dag.',
    managerTidies: 'Je manager ruimt de dubbele op.',
    onThisDay: 'Op deze dag',
    where: 'Waar',
    planningNote: 'Notitie van planning',
    planningNoteClose: 'tik ernaast om te sluiten',
    whatToDo: 'Wat wil je doen?',
    extra: {
      title: 'Extra tijd doorgeven',
      blockedHoliday: 'Kan niet: dit is een vakantiedag. Klopt die niet? Vraag je manager hem aan te passen.',
      blockedPublicHoliday: 'Feestdag: vraag je manager',
      hint: 'Teamoverleg, invallen, eerder begonnen of langer gebleven',
    },
    off: {
      title: 'Vrij vragen',
      past: 'Deze dag is al geweest',
      alreadyLeave: 'Je hebt al verlof op deze dag',
      notWorking: 'Je werkt deze dag niet',
      hint: 'Hele dag of een deel, uit vakantie of extra uren',
    },
    fix: {
      title: 'Mijn uren aanpassen',
      blockedHoliday: 'Op een vakantiedag: vraag je manager het verlof in te korten',
      hint: 'Minder gewerkt, pauze gemist of je rooster was anders',
    },
  },
  leaveForm: {
    back: 'Terug',
    hoursFromRoster: 'uren komen uit je rooster',
    prioNote:
      'Gaat standaard <b>niet</b> van je vakantiesaldo af. Je aanvraag gaat met voorrang naar je manager, die beslist hoe het wordt verrekend en om een bewijs kan vragen.',
    callManager: 'Begint je dienst zo? Bel je manager ook, dan kan die vervanging regelen.',
    appointmentNote: 'Standaard van je vakantie-uren. Je manager beslist hoe het wordt verrekend.',
    from: 'Van',
    until: 'Tot en met',
    wholeDay: 'Hele dag',
    partOfDay: 'Deel van de dag',
    hoursOff: 'Uren vrij',
    workUntilFrom: 'Ik werk tot / vanaf',
    workUntilPlaceholder: 'bijv. tot 14:00',
    workUntil: 'tot',
    workFrom: 'vanaf',
    noWorkingDays: 'Geen werkdagen in deze periode.',
    noFixedRoster: 'Geen vast rooster — je manager stelt dit in; de uren worden daarna berekend.',
    afterContract: 'Na je huidige contract (tot {{date}}). Voorlopig: deze dagen gelden zodra je contract is verlengd.',
    noContractAfterEnd: 'Volgens je contractgegevens liep je contract tot en met {{date}}. Voor de gekozen periode staat geen actief contract geregistreerd. Neem contact op met je manager.',
    noActiveContract: 'Voor de gekozen periode staat geen actief contract geregistreerd. Neem contact op met je manager.',
    offDayZero: '{{name}} 0 u',
    closureDay: 'sluitingsdag',
    takeFrom: 'Neem op uit',
    source: { vacation: 'Vakantie', extra: 'Extra uren', both: 'Beide' },
    extraAvailable: 'te gebruiken',
    stillAwaiting: 'wacht nog op akkoord',
    pastBlocked:
      'Deze dag is al geweest. Vrij achteraf? Kies <b>Zorg</b> of <b>Bijzonder</b>, of vraag je manager.',
    beyondHorizon: 'Vrij aanvragen kan tot en met 31 december {{year}}.',
    alreadyLeaveOn: 'Je hebt al verlof op',
    costs: 'Dit kost',
    holiday: 'vakantie',
    extraHours: 'extra uren',
    afterApproval: 'Na akkoord',
    free: 'vrij',
    stripedUntil: 'Tot dan blijft het gestreept staan.',
    negativeWarning: 'Je saldo gaat negatief. De manager beslist bij goedkeuring (terugwerken of inhouden, zie handboek).',
    openingInReview: 'Je saldo kan nog wijzigen: beginsaldo 2026 is nog in review.',
    message: 'Bericht aan je manager (optioneel)',
    messagePlaceholder: 'Bijv. met wie je dit al hebt afgestemd',
    cancel: 'Annuleren',
    send: 'Verstuur aanvraag',
    sentPriority: 'Met voorrang naar je manager verstuurd',
    sent: 'Verstuurd naar je manager voor akkoord',
  },
  extraForm: {
    title: 'Extra tijd doorgeven',
    crumb: 'Vul in wanneer je het echt deed, ook als dat vóór je dienst was.',
    date: 'Datum',
    from: 'Van',
    until: 'Tot',
    whatFor: 'Waarvoor',
    presets: {
      teamMeeting: 'Teamoverleg',
      covering: 'Invallen voor een collega',
      startedEarly: 'Eerder begonnen',
      stayedLate: 'Langer gebleven',
      training: 'Training / cursus',
    },
    notePlaceholder: 'Korte toelichting (optioneel)',
    countsAsWork:
      'Telt als werktijd: overleg, training, openen en sluiten, kinderen halen en brengen. Zorg voor een ander of een afspraak? Dat is <b>verlof</b>, geen extra tijd.',
    blockedHoliday:
      'Op {{date}} ben je met vakantie. Extra tijd op een vakantiedag kan niet. Klopt je vakantie niet? Vraag je manager die aan te passen.',
    blockedFuture: 'Extra tijd geef je door op of na de dag zelf.',
    blockedInsideRoster: 'Dit valt in je rooster ({{from}}–{{to}}). Extra tijd is tijd buiten je dienst.',
    preview: 'na akkoord. Tot dan staat het gestreept op',
    cancel: 'Annuleren',
    send: 'Verstuur',
  },
  fixForm: {
    title: 'Mijn uren aanpassen',
    workedLess: 'Minder gewerkt',
    missedBreak: 'Pauze gemist',
    date: 'Datum',
    howManyLess: 'Hoeveel uur minder dan je rooster?',
    howMuchBreak: 'Hoeveel pauze heb je gemist?',
    whatHappened: 'Wat gebeurde er?',
    placeholderLess: 'Bijv. BSO eerder dicht',
    placeholderBreak: 'Bijv. alleen op de groep',
    preview: 'op je jaaruren na akkoord.',
    cancel: 'Annuleren',
    send: 'Verstuur',
  },
  picker: {
    title: 'Wat wil je doen?',
    tip: 'Tip: tik op een dag in Mijn week, dan staat de datum al klaar.',
    timeOff: 'Vrij',
    vacation: { title: 'Vakantie', body: 'Tijd om op te laden! Kies je data en stuur ze naar je manager voor akkoord.' },
    appointment: {
      title: 'Dokter of tandarts',
      body: 'Goed voor jezelf zorgen hoort er ook bij. Vraag de tijd aan die je nodig hebt; je manager bekijkt het.',
    },
    care_short: {
      title: 'Zorg voor een ander',
      body: 'Iemand dichtbij heeft zorg nodig. Vertel ons wat je nodig hebt; je manager krijgt het als aanvraag met voorrang.',
    },
    special: {
      title: 'Bijzonder verlof',
      body: 'Voor de grote momenten in het leven en moeilijke afscheiden. Vertel ons wat je nodig hebt; je aanvraag komt bovenaan de lijst van je manager.',
    },
    priority: 'Prioriteit',
    spend: {
      title: 'Extra uren gebruiken',
      zero: 'Je saldo is 0 uur. Zodra je uren hebt, kun je hier vrij aanvragen.',
      body: 'Je hebt de uren gemaakt. Vraag er een deel van terug als vrije tijd, met akkoord van je manager.',
      available: 'Te gebruiken',
      awaiting: '{{hours}} wacht nog op akkoord.',
    },
    hoursWorked: 'Gewerkte uren',
    extra: {
      title: 'Extra tijd doorgeven',
      body: 'Elk extra stukje telt. Vul je begin- en eindtijd in, ook als je vóór of na je dienst werkte, zodat je manager het kan bekijken.',
    },
    fix: {
      title: 'Mijn uren aanpassen',
      body: 'Minder gewerkt, pauze gemist of een foutje gezien? Vertel wat er gebeurde, dan kan je manager de correctie bekijken.',
    },
    sick: 'Voel je je zelf niet goed? Bel je manager vóór 7:00 uur, zodat we vervanging kunnen regelen. Ziekmelden gaat altijd telefonisch.',
  },
  spend: {
    title: 'Extra uren gebruiken',
    approved: 'goedgekeurd',
    alreadyRequested: 'al aangevraagd',
    stillAwaiting: 'wacht nog op akkoord',
    zero: 'Je saldo is 0 uur. Zodra je uren hebt, kun je hier vrij aanvragen.',
    seeWaiting: 'Bekijk wat er wacht',
    verlof: { title: 'Vrij nemen', body: 'Alle {{hours}} erbij als verlof-uren' },
    part: { title: 'Een deel vrij nemen', body: 'Kies zelf hoeveel van je {{hours}}' },
    timeOffHours: 'Vrij (u)',
    total: 'Totaal',
    of: 'van',
    policy: 'Verlofuren worden opgenomen, niet uitbetaald; wat je niet opneemt blijft staan als vrije tijd.',
    agreeTogether: 'Jij en je manager spreken dit samen af: pas na akkoord gaat het van je extra uren af.',
    cancel: 'Annuleren',
    send: 'Verstuur',
    sent: 'Verstuurd naar je manager voor akkoord',
  },
  receipt: {
    why: 'Waarom',
    asOfToday: 'Stand vandaag',
    workingDaysOf: 'werkdagen van gemiddeld',
    carriedOver: 'Meegenomen uit {{year}}',
    builtUp: 'Opgebouwd {{year}} (jaarrecht)',
    statutory: 'wettelijk',
    extraStatutory: 'bovenwettelijk',
    freeToTake: 'Vrij te nemen',
    withheld: 'Saldo nog niet beschikbaar',
    zeroHolidaysTitle: '{{count}} vakanties telden 0 u',
    extraHours: 'Extra uren',
    approvedMinusLess: 'Goedgekeurd extra − minder gewerkt',
    meeruren: 'meeruren',
    used: 'Gebruikt (vrij of uitbetaald)',
    awaitingApproval: 'Wacht op akkoord',
    requests: 'aanvragen',
    extraNegative: 'Je extra uren staan in de min. Je manager kijkt samen met je hoe dit wordt verrekend.',
    allLines: 'Alle regels',
    useExtra: 'Extra uren gebruiken',
  },
  ledger: {
    back: 'Terug naar de som',
    title: 'Alle regels',
    crumb: 'Elke regel telt op tot je saldo. Tussen haakjes = wacht op akkoord, telt nog niet.',
    entitlement: 'Jaarrecht {{year}}',
    holidayHours: 'Vakantie-uren',
    extraHours: 'Extra uren',
    from: 'uit',
    nothingYet: 'Nog niets',
  },
  voorlopig: {
    title: 'Waarom “voorlopig”?',
    intro: 'Je saldo is nu waarschijnlijk <b>te hoog</b>. Twee dingen zijn nog niet af:',
    oldBalance: 'Je oude saldo uit {{year}}',
    oldBalanceNote: 'HR controleert de overgezette saldi van iedereen; daarna komt het hier als “meegenomen”.',
    stillOpen: 'nog open',
    zeroHolidays: '{{count}} vakanties telden 0 u',
    zeroHolidaysNote: 'je rooster van vóór {{date}} staat nog niet in het systeem',
    view: 'bekijk',
    outro: 'Plan gerust, maar reken op een lager getal zodra dit klaar is. Je ziet hier precies wat er verandert, met de reden erbij.',
  },
  answer: {
    title: 'Vraag van je manager',
    yourAnswer: 'Jouw antwoord',
    convertTitle: 'Het was zorg voor een ander (ziek kind)',
    convertBody: 'Zet om naar een zorgaanvraag met voorrang en trek deze extra tijd in. Je manager beslist hoe het wordt verrekend.',
    later: 'Later',
    send: 'Stuur antwoord',
    sent: 'Antwoord naar je manager gestuurd',
    sentPriority: 'Met voorrang naar je manager verstuurd',
  },
  year: {
    clocks: {
      daysToDec: 'dagen tot 31 dec<br/>jaaruren naar 0',
      dec31: '31 dec',
      choiceMade: 'keuze bovenwettelijk gemaakt',
      chooseExtra: 'kies wat je met je bovenwettelijke uren doet',
    },
    yearHours: 'Jaaruren',
    intro: 'Je contract telt in jaaruren: per maand mag je wat meer of minder werken, op 31 december staat het weer op 0.',
    rosterVsContract: 'Rooster anders dan contract',
    rosterVsContractNote: '{{date}} uit je rooster gehaald (−{{hours}}) · gemeten sinds {{from}}',
    patternVsContract: 'Rooster t.o.v. contract',
    extraHours: 'Extra uren',
    extraHoursNote: 'goedgekeurd, min wat je al gebruikte',
    yearHoursNow: 'Jaaruren nu',
    awaitingApproval: 'Wacht op akkoord',
    then: 'daarna',
    onDec31: 'Op 31 december',
    in: 'nog',
    days: 'dagen',
    minusLapse: 'staan er min-uren, dan vervallen die. <b>Die komen voor rekening van Teddy Kids</b>, niet voor jou.',
    plusAgree: 'staan er plus-uren, dan spreek je met je manager af: geld of vrije tijd.',
    exactlyZero: 'staat het precies op 0.',
    limit: 'Grens',
    capBso: 'gemiddeld 1 maand, omdat je ook op de BSO werkt',
    capKdv: 'gemiddeld 2 weken',
    byMonth: '{{year}} per maand',
    legend: {
      holiday: 'vakantie',
      zeroHoliday: 'vakantie die 0 u telde',
      requested: 'aangevraagd',
      bottomNumber: 'getal onderaan = jaaruren eind maand (— = geen rooster)',
    },
    monthHoliday: 'vakantie',
    monthRequested: 'aangevraagd',
    monthYearHours: 'jaaruren',
    noRoster: 'geen rooster',
    nothingThisMonth: 'Niets in deze maand.',
    rosterFromPin: '{{date}}: vanaf hier staat je rooster in het systeem.',
    dec31Pin: '31 dec: jaaruren naar 0 · bovenwettelijke keuze gaat in.',
    statutoryLot: 'Wettelijk {{year}}',
    extraLot: 'Bovenwettelijk {{year}}',
    incl: 'incl.',
    fromExtraHours: 'uit extra uren',
    chooseBefore: 'Kies vóór 31 december',
    chooseQuestion: 'Wat moet er gebeuren met je bovenwettelijke uren die eind {{year}} over zijn?',
    choice: {
      save: { title: 'Sparen', body: 'Blijft 5 jaar staan · max 330 u in totaal' },
      take: { title: 'Nog opnemen', body: 'Plan ze vóór 31 december als vakantie' },
    },
    yourChoice: 'Jouw keuze',
    changeUntil: 'Je kunt dit tot 31 december wijzigen.',
    caoDefault: 'Kies je niets, dan betalen we ze uit op 31 december. Zo staat het in de cao.',
    choiceSaved: 'Keuze opgeslagen',
  },
  errors: {
    PLUS_HOURS_INSUFFICIENT: 'Niet genoeg extra uren: nodig {{needed}} u, beschikbaar is {{available}} u.',
    PLUS_HOURS_INSUFFICIENT_plain: 'Niet genoeg extra uren beschikbaar.',
    VACATION_BALANCE_INSUFFICIENT: 'Het vakantiesaldo gaat negatief: na dit besluit {{after}} u. Vink "Toch goedkeuren" aan om door te gaan.',
    VACATION_BALANCE_INSUFFICIENT_plain: 'Het vakantiesaldo gaat negatief. Vink "Toch goedkeuren" aan om door te gaan.',
    COLLISION_FULL_LEAVE_DAY: 'Op deze dag staat een hele dag verlof: dit zou dubbel tellen.',
    DECISION_NOTE_REQUIRED: 'Een afwijzing heeft een toelichting nodig.',
    DECISION_MINUTES_EXCEED: 'Je kunt niet meer dan de aangevraagde uren bij de vakantie-uren zetten.',
    DECISION_KIND_UNSUPPORTED: 'Alleen gewerkte tijd (extra tijd of een gemiste pauze) kan bij de vakantie-uren.',
    REQUEST_NOT_PENDING: 'Deze aanvraag wacht niet meer op een besluit.',
    REQUEST_NOT_FOUND: 'Deze aanvraag bestaat niet meer, of je kunt hem niet openen.',
    DECIDE_FORBIDDEN: 'Alleen een manager kan hierover beslissen.',
    SELF_DECIDE_FORBIDDEN: 'Over je eigen aanvraag beslist een andere manager.',
  },
  manager: {
    viewMeta: 'Managerweergave · contract {{hours}} u/week · {{group}}',
    freeToTake: 'vrij te nemen',
    extraHours: 'extra uren',
    open: 'open',
    yearHours: 'jaaruren',
    sameNumbers:
      'Dezelfde getallen als {{name}} in haar app ziet: één berekening voor iedereen. Jij kiest bij elk akkoord hoe de uren worden verrekend; {{name}} ziet dat besluit bij haar regel.',
    flagsTitle: 'Let op.',
    zeroBody_one: '{{count}} vakantie van {{name}} vanaf 1 aug telde 0 u.',
    zeroBody_other: '{{count}} vakanties van {{name}} vanaf 1 aug telden 0 u.',
    doubleBooked: '{{date}} staat dubbel geboekt.',
    yearEndChoice: 'Keuze: {{choice}}',
    yearEndNone: 'nog geen keuze → blijft staan als vrije tijd',
    payoutStored: 'keuze vóór 30 sep; wordt niet uitbetaald',
    // Vaststellen on the Portabase box (hours cutover mock rev 3, boxHtml(mgr) / openRatify).
    ratify: {
      button: 'Vaststellen',
      title: 'Portabase-saldo vaststellen?',
      crumbs: '{{name}} · stand 20 jul 2026',
      total: 'Portabase-saldo 20 jul = Beginsaldo LMS',
      after: 'Vaststellen bevestigt alleen dit blok. Er verandert geen getal: niet in de dagen, niet in Onze berekening, niet op Mijn week.',
      cancel: 'Annuleren',
      done: 'Vastgesteld door {{name}} · {{date}}',
      unknownUser: 'onbekende gebruiker',
      toast: 'Vastgesteld · {{date}}',
      fixInVerlofcentrum: 'Openingssaldi corrigeren in het Verlofcentrum',
    },
    waitingForYou: 'Wacht op jou',
    allDecided: 'Alles is beslist.',
    priority: 'Prioriteit',
    clashHoliday: 'Botsing: vakantiedag',
    noFixedRoster: 'Geen vast rooster',
    noFixedRosterHint: 'Uren nog 0 — rooster eerst instellen. Goedkeuren kan; het saldo rekent de uren zodra het vaste rooster er is.',
    afterContractEnd: 'Na contracteinde',
    afterContractEndHint: 'Contract loopt tot {{date}}. Goedkeuren kan; de dagen gelden zodra het contract is verlengd.',
    goesNegative: '⚠ gaat negatief {{hours}}',
    negativeOverride: 'Toch goedkeuren: vakantiesaldo wordt {{hours}}',
    negativeOverrideHint: 'Het saldo gaat onder nul. Je keuze wordt bij het besluit vastgelegd.',
    openingInReview: 'beginsaldo in review',
    dayRemoved: 'dag was uit rooster gehaald',
    questionAsked: 'vraag gesteld',
    jevAdvice: 'Advies van Jev, jij beslist',
    jev: { readsAsLeave: 'Leest als verlof', sameDayHoliday: 'Zelfde dag als vakantie', askTeacher: 'Vraag de teacher' },
    shift: 'Dienst',
    answer: 'antwoord',
    openSince: 'open sinds',
    days: 'dagen',
    fromExtraHours: 'uit extra uren',
    howToSettle: 'Hoe verrekenen?',
    settle: {
      asFiled: 'Zoals aangevraagd',
      vacation: 'Vakantie-uren',
      extra: 'Extra uren',
      none: 'Niet van saldo (zorgverlof / bijzonder)',
    },
    effect: {
      noneLeaveAsExtra: '0 u · het was verlof (zorg / bijzonder), telt niet als extra',
      noneNotFromBalance: '0 u · niet van haar saldo (bijv. locatie dicht, uitvaart)',
      noneCareSpecial: '0 u · zorgverlof / bijzonder verlof',
      vacationPlus: '+{{hours}} bij haar vakantie-uren (bovenwettelijk)',
      vacationMinus: '−{{hours}} van haar vakantie-uren → {{after}} vrij',
      extraPlus: '+{{hours}} bij haar extra uren → {{after}}',
      extraMinus: '−{{hours}} uit haar extra uren → {{after}}',
      goesNegative: ' (wordt negatief)',
    },
    defaultLabel: {
      vacation: 'vakantie-uren',
      extra: 'extra uren',
      none: 'niet van saldo',
      split: '{{vacation}} vakantie + {{extra}} extra',
    },
    collisionDisabled: 'Kan niet: ook een volle vakantiedag, dan telt het dubbel',
    seesDecision: '{{name}} ziet jouw besluit bij haar aanvraag, op de dag en in haar overzicht.',
    reasonRequired: 'Reden (verplicht, {{name}} ziet dit)',
    questionTo: 'Je vraag aan {{name}}',
    noteOptional: 'Notitie (optioneel)',
    cancel: 'Annuleren',
    decline: 'Afwijzen',
    sendQuestion: 'Vraag sturen',
    approve: 'Goedkeuren',
    askQuestion: 'Vraag stellen',
    collisionHint: 'Ook een volle vakantiedag: goedkeuren kan alleen als “niet van saldo”, anders telt het dubbel.',
    approvedToast: 'Goedgekeurd',
    toastSettle: { vacation: 'vakantie-uren', extra: 'extra uren', none: 'niet van saldo', split: 'zoals aangevraagd' },
    declinedToast: 'Afgewezen, met reden',
    questionSentToast: 'Vraag gestuurd naar {{name}}',
    requested: 'aangevraagd',
    processedChip: 'verwerkt',
    processedButton: 'Verwerkt',
    markedProcessed: 'Gemarkeerd als verwerkt',
    groupLog: {
      title: 'Eén keer loggen voor de groep',
      body: 'Teamoverleg, coachavond of open dag: jij logt het één keer, iedereen die erbij was krijgt het goedgekeurd bij zijn extra uren.',
      what: 'Wat',
      date: 'Datum',
      from: 'Van',
      until: 'Tot',
      defaultLabel: 'Teamoverleg',
      attendeesHint: 'In de app staat hier iedereen die die dag op {{group}} stond',
      logFor_one: 'Log voor {{count}} medewerker',
      logFor_other: 'Log voor {{count}} medewerkers',
      onHoliday: '{{name}} heeft vakantie op {{date}}: niet gelogd',
      logged_one: 'Gelogd voor {{count}} medewerker',
      logged_other: 'Gelogd voor {{count}} medewerkers',
      selfExcluded: 'jij — log je eigen uren via Extra tijd gewerkt',
    },
  },
  hero: {
    label: 'Vrij te nemen',
    aria: 'Waarom dit getal',
    approxDays: '≈ {{n}} dagen',
    legend: { taken: 'Opgenomen', planned: 'Gepland', requested: 'Aangevraagd', free: 'Nog vrij' },
    pendingLine: '<b>{{hours}} wacht op akkoord</b>, nog niet afgetrokken. Na akkoord: <b>{{after}}</b>.',
    boxLine: 'Start <b>{{start}}</b> (Portabase-blok) · verlof in LMS vanaf 1 aug <b>{{leave}}</b>',
    accruedLine: 'Opgebouwd t/m vandaag {{accrued}} van {{grant}} jaarrecht',
    ask: 'Vrij vragen',
  },
  yearEnd: {
    title: 'Kies vóór 31 december',
    daysLeft: 'nog {{n}} dagen',
    question: 'Wat doe je met je <b>{{hours}} bovenwettelijke uren {{year}}</b>?',
    options: {
      use: { title: 'Opnemen', sub: 'vóór 31 dec' },
      save: { title: 'Sparen', sub: 'blijft staan tot je ze opneemt' },
      payout: { title: 'Uitbetalen' },
    },
    none: 'Wat je niet opneemt, blijft staan als vrije tijd.',
    use: 'Je neemt ze nog op. Wat je niet opneemt, blijft staan als vrije tijd.',
    save: 'Gespaard. Totaal gespaard: <b>{{total}}</b> van max. {{cap}} u.',
    saveProvisional: 'Gespaard. Totaal gespaard: <b>{{total}}</b> van max. {{cap}} u (Portabase-saldo nog voorlopig).',
    saved: 'Keuze opgeslagen. Je kunt dit tot 31 dec wijzigen.',
  },
  // Hours cutover — verbatim from ~/mockups/2026-09/hours-cutover.html rev 3 (plan
  // docs/plans/2026-09-30-hours-cutover-portabase-box.md T2). Not in the mock (states it
  // does not show): box.noBox, box.postCutoverHire, calc.requestsInside, calc.conversions,
  // calc.corrections, calc.writtenOff; calc.extraTitle drops the mock's "vanaf 1 aug"
  // (the extra-hours pot is not cut over on 1 Aug).
  cutover: {
    blocks: { box: 'Portabase · 20 jul 2026', days: 'Dag voor dag vanaf 1 aug · alleen LMS', calc: 'Onze berekening' },
    box: {
      title: 'Portabase-saldo',
      confirmed: 'vastgesteld {{date}}',
      source: 'Stand 20 jul 2026 · overgenomen uit Portabase · bevroren: LMS rekent hier nooit in',
      inAdvance: 'vooruit opgenomen',
      showZero: '+ {{count}} potjes op 0 u tonen',
      hideZero: '{{count}} lege potjes verbergen',
      excluded: 'Bovenwettelijk t/m 2024 is uitbetaald onder de oude regeling en telt niet mee.',
      opening: 'Beginsaldo LMS · 1 aug 2026',
      openingSub: '= Portabase-saldo 20 jul · som van de {{count}} regels hierboven, zoals geïmporteerd',
      closing: 'Alles tot en met 31 jul zit in dit blok en wordt nooit opnieuw berekend. Verlof vanaf 1 aug dat al in Portabase stond, is hierin al verrekend.',
      staysAsTimeOff: 'Wat je niet opneemt, blijft staan als vrije tijd.',
      other: 'Overige Portabase-saldi (niet vrij te nemen)',
      otherSub: '{{count}} sectie(s) · tik voor het bedrag per sectie',
      otherNone: 'geen in Portabase',
      confirmedDock: 'Portabase vastgesteld',
      withheld: {
        no_contract_hours: 'Er staan nog geen contracturen voor je in Employes. Vraag je manager dit te regelen.',
        flex_contract_unsupported: 'Voor een flexcontract (0 uur) houden we hier geen vakantiesaldo bij.',
        no_contract_history: 'Je contractgeschiedenis uit Employes ontbreekt nog. Vraag je manager dit te regelen.',
      },
      noBox: 'Er staat nog geen Portabase-saldo van 20 jul voor je klaar. HR zet het erin.',
      postCutoverHire: 'Je bent na 1 aug begonnen, dus je hebt geen Portabase-saldo. Je uren bouw je op in LMS.',
    },
    lotSheet: {
      crumbs: 'Portabase-saldo 20 jul 2026 · precies zoals geïmporteerd',
      hours: 'Uren',
      kind: 'Soort',
      year: 'Jaar',
      status: 'Status',
      negative:
        'Vooruit opgenomen: in Portabase is meer wettelijk verlof opgenomen dan er was opgebouwd. We tonen het precies zoals het in Portabase staat en telt zo mee in je beginsaldo, niets wordt afgerond of op 0 gezet.',
      statutory: 'Wettelijk verlof: het minimum uit de wet. Je uren blijven staan tot je ze opneemt.',
      extra: 'Bovenwettelijk verlof uit de cao. Wat je niet opneemt, blijft staan als vrije tijd.',
      zero: 'Dit potje staat op 0 u.',
    },
    otherSheet: {
      title: 'Overige Portabase-saldi',
      crumbs: 'Stand 20 jul 2026 · zoals geïmporteerd · niet vrij te nemen, telt nooit mee in Vrij te nemen',
      section: 'sectie',
    },
    close: 'Sluiten',
    days: {
      cols: { day: 'Dag', roster: 'Rooster', away: 'Afwezig', extra: 'Extra', free: '± vrij' },
      sum: { roster: 'Rooster', away: 'Afwezig', extra: 'Extra', free: '± Vrij' },
      dayOff: 'vrije dag · geen rooster',
      noRoster: 'geen rooster',
      planned: 'gepland',
      holiday: 'vakantie',
      holidayNoRoster: 'vakantie · geen rooster, 0 u',
      settled: 'al verrekend in Portabase',
      legend:
        'Afwezig = vakantie tegen je LMS-rooster van die dag · ± vrij = wat de dag doet met Vrij te nemen (verlof dat al in Portabase stond: 0) · gestreept = wacht op akkoord, telt nog niet',
    },
    calc: {
      title: 'Onze berekening',
      intro: 'Start bij het Portabase-blok en telt alleen wat vanaf 1 aug in LMS gebeurde.',
      opening: 'Beginsaldo uit het Portabase-blok',
      openingSub: '= Portabase-saldo 20 jul, zoals geïmporteerd',
      settled: 'Verlof vanaf 1 aug uit Portabase',
      settledSub: '{{count}} dagen · al verrekend in Portabase, telt 0',
      taken: 'Verlof vanaf 1 aug (LMS-uren) · opgenomen',
      takenSub: '{{count}} dagen t/m vandaag · in LMS aangevraagd · rooster van die dag',
      planned: 'Verlof vanaf 1 aug (LMS-uren) · gepland',
      plannedSub: '{{count}} dagen · goedgekeurd, na vandaag',
      requests: 'Aanvragen verrekend als vakantie-uren',
      requestsSub: 'extra tijd en correcties vanaf 1 aug, besluit manager',
      requestsPending: '{{count}} wacht(en) op akkoord, telt nog niet',
      requestsInside: 'al meegeteld in het verlof hierboven',
      conversions: 'Extra uren omgezet naar vakantie-uren',
      corrections: 'Correcties door HR',
      writtenOff: 'Afgeboekt door HR',
      extraTitle: 'Extra uren (meeruren)',
      negative:
        'Onder nul: in Portabase is meer wettelijk verlof opgenomen dan er was opgebouwd (vooruit opgenomen). We tonen het zoals het is.',
      same: 'Zelfde getal als op Mijn week: <b>{{hours}}</b>',
    },
    dayList: {
      settledTitle: 'Al verrekend in Portabase',
      takenTitle: 'Opgenomen vanaf 1 aug',
      plannedTitle: 'Gepland',
      settledCrumbs: 'Stond al in Portabase op 20 jul · afwezig volgens je LMS-rooster, telt 0 van je saldo',
      crumbs: 'In LMS aangevraagd · vakantie tegen je LMS-rooster van die dag · één keer per dag',
      total: 'Totaal',
      nothing: 'Niets.',
    },
    nudge: { title: 'Plan je vrije dagen', body: 'je uren blijven staan tot je ze opneemt' },
  },
  // Reiskosten (km) — verbatim from ~/mockups/2026-09/km-reiskosten-week.html rev 2
  // (plan docs/plans/2026-09-28-reiskosten-km.md Task 3). errors.*, kmLoading,
  // kmToLoading, noCurrent, streetInvalid and unknownKm are not in the mock (states it does not show).
  reiskosten: {
    card: {
      title: '📍 Klopt je adres nog?',
      source: 'Uit je personeelsdossier (Employes). Hier betalen we je reiskosten op.',
      kmChip: '🚲 {{km}} km enkele reis → {{loc}}',
      perDayChip: '{{amount}} per gewerkte dag',
      kmLoading: '🚲 km wordt berekend…',
      kmUnknown: 'km onbekend — {{reason}}',
      locationMissing: 'hoofdlocatie nog niet gekoppeld',
      recalcFailed: '⚠️ herberekening mislukt',
      confirm: 'Klopt ✓',
      edit: 'Wijzigen',
      explain:
        '{{kmDay}} km per dag × {{rate}} (cao kinderopvang vanaf 1 jul 2026). Alleen dagen die je echt werkt tellen mee. Verhuis je? Geef de datum door: vanaf die dag rekenen we met je nieuwe adres.',
      confirmedToast: 'Adres bevestigd · {{date}}',
      kmTo: '{{km}} km → {{loc}}',
      kmToLoading: 'km wordt berekend → {{loc}}',
      kmToUnknown: 'km onbekend → {{loc}}',
      okLine: '📍 {{street}}, {{city}} · {{km}} · ',
      confirmedOn: 'bevestigd {{date}}',
      pendingChip: '⏳ wijziging doorgegeven',
      withdraw: 'Intrekken',
      withdrawnToast: 'Wijziging ingetrokken',
      nextLine: '🏡 Vanaf {{date}}: {{street}}, {{city}} · {{km}} · ',
      processedChip: 'verwerkt door Antonella',
      noReisTitle: 'Je ontvangt geen reiskosten.',
      noReisBody: 'Reden: {{reason}} (ingesteld {{date}}). Klopt dit niet? Vraag het je manager.',
      noCurrent: 'Er is geen adres dat vandaag geldt. Vraag je manager om je adres in Employes te zetten.',
    },
    sheet: {
      title: 'Adres wijzigen',
      intro: 'Antonella zet het in Employes; daarna rekenen we je km opnieuw uit. Tot die tijd blijft het oude adres gelden.',
      street: 'Straat + huisnummer',
      zip: 'Postcode',
      city: 'Plaats',
      from: 'Woon je hier vanaf',
      preview: 'Nieuwe afstand: <b>wordt berekend na opslaan</b> · nu {{km}}',
      cancel: 'Annuleren',
      send: 'Doorgeven',
      sentToast: 'Doorgegeven aan Antonella · km volgen na verwerking',
      streetInvalid: 'Vul straat en huisnummer in, bijvoorbeeld Voorbeeldstraat 12.',
    },
    gewerkt: {
      distanceUnknown: 'Afstand onbekend',
      running: 'maand loopt nog',
      movedOn: 'verhuisd per {{date}}',
      prev: 'Vorige maand',
      next: 'Volgende maand',
      tiles: { days: 'dagen', hours: 'uur', km: 'km', money: 'reiskosten' },
      cols: { day: 'Dag', roster: 'Rooster', worked: 'Gewerkt', status: 'Status', km: 'Km' },
      week: 'Week {{n}}',
      planned: 'gepland',
      status: { work: 'gewerkt', extra: 'extra dag', vac: 'vakantie', sick: 'ziek', hol: 'feestdag' },
      noReisTitle: 'ontvangt geen reiskosten',
      daysToToday_one: '{{count}} dag t/m vandaag',
      daysToToday_other: '{{count}} dagen t/m vandaag',
      formula_one: '{{count}} dag × {{km}} km × {{rate}}',
      formula_other: '{{count}} dagen × {{km}} km × {{rate}}',
      total: 'Reiskosten {{month}}',
      none: 'Geen reiskosten ({{reason}})',
      unknownKm_one: '{{count}} dag zonder km (km onbekend)',
      unknownKm_other: '{{count}} dagen zonder km (km onbekend)',
      legendKm: 'km ✓ = home → {{loc}} × 2',
      hint: 'Je reiskosten gaan automatisch mee met je salaris van {{month}}. Klopt een dag niet? Tik op Mijn week en pas de uren aan, de km volgen.',
    },
    errors: {
      NO_EMPLOYES_LINK: 'Je staat nog niet gekoppeld aan Employes. Vraag je manager om dit te regelen.',
      NO_EMPLOYES_ADDRESS: 'Er staat nog geen adres in Employes. Vraag je manager om je adres in te voeren.',
      EMPLOYES_ADDRESS_INCOMPLETE: 'Je adres in Employes is niet compleet. Vraag je manager om het aan te vullen.',
      NO_MAIN_LOCATION: 'Je hebt nog geen hoofdlocatie. Vraag je manager om die in te stellen.',
      NO_START_DATE: 'Je startdatum is nog onbekend. Vul die eerst in.',
      ADDRESS_INVALID: 'Vul straat, huisnummer, postcode en plaats in.',
      EFFECTIVE_FROM_TOO_EARLY: 'Die datum ligt te ver terug (maximaal 31 dagen).',
      REQUEST_ALREADY_PENDING: 'Er wacht al een adreswijziging op Antonella.',
      ADDRESS_NOT_CONFIRMABLE: 'Dit adres kun je niet bevestigen.',
      REQUEST_NOT_PENDING: 'Deze wijziging wacht niet meer: Antonella heeft haar al verwerkt.',
    },
  },
  // Teddy Gala RSVP card on /my-schedule — verbatim from the ratified golden mock
  // docs/plans/assets/teddy-gala-rsvp-mock.html (Artem 2026-09-28).
  gala: {
    posterAlt: 'Christmas Dinner 2026 poster',
    kicker: '🎄 Teddy Kids',
    title: 'Christmas Dinner 2026',
    sub: 'Een avond om ons geweldige team te vieren. Masquerade party!',
    chipDate: '📅 {{date}}',
    chipTime: '🕡 {{from}}–{{to}}',
    chipLocation: '📍 Geheime locatie',
    chipCourses: '🍽 5 gangen',
    chipDress: '🎭 Christmas Gala',
    question: 'Kom je?',
    yes: '🎉 Ja, ik kom!',
    no: 'Nee, helaas',
    foot: "<b>{{n}}</b> collega's komen al · antwoord vóór 12 dec",
    yesTitle: 'Je komt, {{name}}! Tot 19 december 🥂',
    yesTitleNoName: 'Je komt! Tot 19 december 🥂',
    yesSub: 'za 19 dec · 18:30 · Locatie hoor je 1 uur van tevoren<br/>Dresscode: Christmas Gala · masquerade',
    change: 'wijzigen',
    closed: 'Antwoorden gesloten',
    reasonLabel: 'Jammer! Waarom kun je niet?',
    reasonHelp: 'Vertel het kort — minimaal 7 woorden, dan kunnen we eventueel meedenken.',
    reasonPlaceholder: 'Bijv. Ik werk die avond bij mijn tweede baan en kan niet ruilen…',
    counter: '{{n}} / {{min}} woorden',
    left: 'nog {{n}}',
    enough: '✓ genoeg',
    back: 'Terug',
    ok: 'OK, afmelden',
    noTitle: 'Jammer, we missen je!',
    noSub: 'Je bent afgemeld voor het Christmas Dinner.<br/>Van gedachten veranderd? Kan tot 12 dec.',
    loadError: 'De Christmas Dinner-kaart kon niet laden.',
    retry: 'Opnieuw',
    reasonTooShort: 'Schrijf minimaal 7 woorden.',
    saveFailed: 'Je antwoord is niet opgeslagen ({{status}}).',
    managerLink: 'Antwoorden bekijken →',
    modalTitle: 'Santa Teddy heeft een vraagje…',
    modalHelp: 'Een kleine kerstuitnodiging voor je verdergaat. Laat je weten of je komt?',
    santaNo: 'Santa Teddy zegt nee nee neeeee… kies eerst even of je komt! 🎅🧸',
    stillThinking: 'Ik denk nog even na…',
    thinkingCount: 'Denkklikjes',
    thinkingHelp: 'Nog geen antwoord opgeslagen. Wel een heel druk denkknopje.',
    thinkingAchievement: '🏅 {{n}} klikjes! Officieel kerstdenker.',
    thinkingPro: '🏆 {{n}} klikjes! Hoofd piekeren bij de Kerstman.',
    thinkingLegend: '🎊 {{n}} klikjes! Legendarische denker. Santa wacht nog op je antwoord!',
  },
  startDateGate: {
    title: 'Wanneer begon je bij Teddy Kids?',
    help: 'Ons HR-systeem heeft voor iedereen die vóór september 2024 begon een tijdelijke datum (1 september 2024). We willen graag je échte eerste werkdag bij Teddy Kids weten.',
    why: 'Die datum telt mee voor je jubileum en je beoordelingen.',
    label: 'Mijn eerste werkdag',
    save: 'Opslaan',
    saving: 'Opslaan…',
    pickDate: 'Kies eerst je eerste werkdag.',
    outOfRange: 'Kies een datum tussen 1 januari 1990 en vandaag.',
    saved: 'Dank je! Je startdatum is opgeslagen.',
  },
  // Vacation notices (plan docs/plans/2026-10-23-teacher-vacation-notices.md, T2;
  // golden mock ~/mockups/2026-10/vacation-notices.html §2 and §4). Card chrome
  // and the manager log only: the notice text itself is stored on the row.
  notices: {
    label: 'Vakantieberichten',
    pill: { lapse_6m: 'Wettelijke kennisgeving', lapse_3m: 'Laatste kennisgeving' },
    ask: 'Vrij vragen',
    later: 'Later',
    gotIt: 'Gelezen',
    emailNote: 'Ook per e-mail verstuurd · blijft staan tot je op Gelezen tikt',
    stayNote: 'Blijft staan tot je op Gelezen tikt',
    loadError: 'Je vakantieberichten konden niet laden.',
    retry: 'Opnieuw',
    ackFailed: 'Opslaan lukte niet: {{message}}',
    log: {
      title: 'Kennisgevingen · {{name}}',
      latest: 'laatste: {{date}} · {{state}}',
      state: { read: 'gelezen', dismissed: 'weggeklikt', seen: 'gezien', unseen: 'nog niet gezien' },
      empty: 'Nog geen kennisgevingen voor {{name}}.',
      loadError: 'De kennisgevingen konden niet laden.',
      col: { date: 'Datum', kind: 'Soort', lot: 'Potje', hours: 'Uren in bericht', lapse: 'Vervalt', email: 'E-mail', push: 'Push', seen: 'Gezien', ack: 'Gelezen' },
      kind: { nudge: 'reminder', lapse_6m: '6 mnd', lapse_3m: '3 mnd' },
      lot: 'wettelijk {{year}}',
      hoursFree: '{{hours}} vrij',
      email: {
        pending: 'bezig',
        sent: 'verstuurd',
        failed: 'mislukt · wordt opnieuw geprobeerd',
        failedNudge: 'mislukt',
        no_address: 'geen e-mailadres',
        needs_check: 'onzeker of verstuurd',
        expired: 'niet gegeven',
        not_sent: 'niet verstuurd',
      },
      sentOn: 'verstuurd {{date}}',
      push: {
        sent_one: '{{count}} apparaat',
        sent_other: '{{count}} apparaten',
        none: 'geen abonnement',
        failed: 'mislukt',
        pending: 'bezig',
        needs_check: 'onzeker',
        not_sent: 'niet verstuurd',
      },
      dismissed: 'weggeklikt',
      footer: 'Niemand kan een regel verwijderen. Gezien en Gelezen zet de app zelf, met de tijd van de database.',
      help: {
        no_address: 'Geen e-mailadres: vul het adres in op de Staff File; de volgende run verstuurt de kennisgeving alsnog.',
        needs_check: 'Onzeker of verstuurd: kijk in Resend of de mail is aangekomen. Zo niet, geef de kennisgeving zelf schriftelijk; de app verstuurt hem niet opnieuw.',
        expired: 'Niet gegeven: de vervaldatum is voorbij of het dienstverband is beëindigd voordat de mail aankwam. Deze kennisgeving telt niet als gegeven.',
      },
    },
  },
  // Wed/Fri combined BSO rooms (plan docs/plans/2026-10-27-wed-fri-combined-groups.md,
  // Task 3): the room line under a combine-day shift and its in-page note.
  room: {
    line: '{{day}}: {{room}} ({{groups}}) · {{building}} · {{kids}} kinderen',
    roomName: '{{label}}-kamer',
    swimRoomName: 'Zwemmers ({{label}})',
    noteTitle: 'Combinatiedag',
    building: 'Gebouw',
    groups: 'Groepen samen',
    kids: 'Kinderen',
    kidsValue: '{{n}} kinderen',
    swimmersLeaving: '{{n}} zwemmers uit deze groepen gaan zwemmen',
    together: 'Tot {{time}} samen in de {{room}}',
    shift: 'Jouw tijd hier: {{start}}–{{end}}',
    close: 'tik ernaast om te sluiten',
  },
} as const;
